var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentNew = function SvgDocumentNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1B216B",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.094 21.743h-19.5v2h19.5zM19.425 15.875h-7.831v2h7.831z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.314 6.125h-10.27a5.383 5.383 0 0 0-5.374 5.374v24.494a5.383 5.383 0 0 0 5.375 5.375h14.844a9 9 0 0 1-1.607-2H13.045a3.377 3.377 0 0 1-3.375-3.375V11.5a3.377 3.377 0 0 1 3.375-3.374h8.281v9.75h11.7l-.012 7.987a8.475 8.475 0 0 1 2-.006l.012-9.207zm.006 2.693 7.85 7.057h-7.85z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.639 27.606H11.595v2h15.094a9.1 9.1 0 0 1 1.95-2M25.027 34.806c0-.45.043-.894.112-1.331H11.602v2h13.462a8 8 0 0 1-.031-.67zM34.026 42.806c-4.412 0-8-3.588-8-8 0-4.413 3.588-8 8-8 4.413 0 8 3.587 8 8 0 4.412-3.587 8-8 8m0-14a6.01 6.01 0 0 0-6 6c0 3.306 2.694 6 6 6s6-2.694 6-6-2.693-6-6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.639 37.812a.52.52 0 0 1-.3-.1l-2.85-2.119.687-.931 2.319 1.725 3.119-4.2.931.688-3.519 4.737a.48.48 0 0 1-.325.194h-.069z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.638 38.187a.88.88 0 0 1-.53-.181l-3.145-2.338 1.138-1.53 2.319 1.724 3.118-4.2 1.538 1.131-3.744 5.038a.86.86 0 0 1-.575.344c-.044 0-.081.006-.119.006zm-2.625-2.669 2.55 1.894s.05.031.075.031h.02s.055-.025.074-.05l3.3-4.437-.325-.244-3.125 4.2-2.319-1.725-.243.325z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export { SvgDocumentNew as Icon };
export default __webpack_public_path__ + "static/media/974e16ab6357e3a0a16664cc18eeb563.svg";